import { useNavigate } from 'react-router-dom';
import { postUpdateAvatar } from '@/api';
import { ImageCropUploadScreen } from '@/components/ui/ImageCropUploadScreen';
import { blobToDataUrl } from '@/lib/imageCrop';

const AVATAR_PREVIEW_SIZES = [
  {
    width: 128,
    height: 128,
    label: 'Large',
    badgeClass: 'bg-green-500',
    imageClass: 'rounded-full object-cover border-4 border-white shadow-md',
  },
  {
    width: 64,
    height: 64,
    label: 'Medium',
    badgeClass: 'bg-gray-500',
    imageClass: 'rounded-full object-cover border-2 border-white shadow',
  },
  {
    width: 36,
    height: 36,
    label: 'Small',
    badgeClass: 'bg-gray-400',
    imageClass: 'rounded-full object-cover border border-white shadow',
  },
];

export default function AvatarUploadPage() {
  const navigate = useNavigate();

  return (
    <ImageCropUploadScreen
      titleSelect="Change Avatar"
      titleCrop="Crop Avatar"
      titlePreview="Preview Avatar"
      uploadPrompt="Upload a new photo"
      uploadHint={'Choose a clear photo of yourself.\nJPG, PNG or WEBP up to 5MB.'}
      previewHeading="How you will look"
      previewSubheading="This is how others will see you"
      saveLabel="Save Avatar"
      confirmLabel="Confirm & Save"
      aspect={1}
      cropShape="round"
      capture="user"
      previewSizes={AVATAR_PREVIEW_SIZES}
      onUpload={async (blob) => {
        const { avatarUrl } = await postUpdateAvatar(blob);
        return avatarUrl ?? (await blobToDataUrl(blob));
      }}
      onSuccess={(uploadedUrl) => {
        localStorage.setItem('userAvatar', uploadedUrl);
        navigate('/me', { replace: true });
      }}
      onBack={() => navigate('/me')}
    />
  );
}
